import { REGULAR_EXPRESSION_CONSTANTS } from '../constants';

export const FileNameUtils = {

    getExtension(fileName: string): string {
        const lastDotIndex = fileName.lastIndexOf('.');
        const hasExtension = lastDotIndex > 0 && lastDotIndex < fileName.length - 1;

        return hasExtension ? fileName.slice(lastDotIndex) : '';
    },

    getBaseName(fileName: string): string {
        const extension = FileNameUtils.getExtension(fileName);

        return fileName.slice(0, fileName.length - extension.length);
    },

    hasInvalidCharacters(name: string): boolean {
        return REGULAR_EXPRESSION_CONSTANTS.fileNameInvalidCharacterPattern.test(name);
    },

    isValid(fileName: string): boolean {
        return FileNameUtils.getBaseName(fileName).trim().length > 0 && !FileNameUtils.hasInvalidCharacters(fileName);
    },

    getInvalidCharacters(fileName: string): string[] {
        return [...new Set(fileName.match(REGULAR_EXPRESSION_CONSTANTS.fileNameInvalidCharacterGlobalPattern))];
    },

    getSuggestedName(fileName: string): string {
        return fileName
            .replace(REGULAR_EXPRESSION_CONSTANTS.fileNameInvalidCharacterGlobalPattern, '_')
            .replace(REGULAR_EXPRESSION_CONSTANTS.repeatedUnderscoresPattern, '_');
    },
};
